{
  "credits": "{{count}} stp.",
  "partTime": "Deltid",
  "showAll": "Vis hele",
  "legend": {
    "courses": "Kjernefag",
    "modules": "Samling",
    "webinars": "Webinar",
    "electives": "Valgkurs"
  },
  "courseDescription": {
    "back": "Tilbake",
    "close": "Lukk",
    "courseContent": "Kursinnhold",
    "disclaimer": "Forbehold",
    "disclaimerText": "Dette er et utdrag fra den komplette kursbeskrivelsen for kurset. Dersom du er aktiv student på BI, kan du finne de komplette kursbeskrivelsene med informasjon om bl.a. læringsmål, læreprosess, pensum og eksamen på portal.bi.no. Vi tar forbehold om endringer i denne beskrivelsen.",
    "error": "Noe gikk galt",
    "errorText": "Kunne ikke laste inn kursbeskrivelsen, det kan hende den ikke er klar enda. Prøv igjen senere.",
    "introduction": "Introduksjon",
    "label": "Kurs",
    "loading": "Laster kursbeskrivelse...",
    "opportunities": {
      "title": "Muligheter i studietiden",
      "empty": "Data mangler, sjekk igjen senere",
      "electives": {
        "chipsHeader": "Valgkurs som",
        "empty": "Fant ingen kurs"
      }
    }
  }
}
